import Debouncer from '../../lib/Debouncer';

export interface ScrolledConfig {
	scrolledClass: string;
	scrolledDistanceClass: string;
	scrollDistanceDown: number;
	scrollDistanceUp: number;
}

/**
 * Adds config.scrolledClass to body if the page has been scrolled,
 * adds config.scrolledDistanceClass to body when scrolled down
 * by config.scrollDistanceDown and removes the same class when
 * scrolled back up by config.scrollDistanceUp
 */
export default class Scrolled {
	constructor(private config: ScrolledConfig) {
		let triggerPoint: number = window.pageYOffset;

		const scrollDebouncer = new Debouncer(() => {
			if (config.scrolledClass !== undefined) {
				if (window.pageYOffset > 0) {
					document.body.classList.add(config.scrolledClass);
				} else {
					document.body.classList.remove(config.scrolledClass);
				}
			}

			if (config.scrolledDistanceClass !== undefined) {
				const diff = window.pageYOffset - triggerPoint;
				if (diff > 0 && diff >= config.scrollDistanceDown) {
					// Scroll down
					triggerPoint = window.pageYOffset;
					document.body.classList.add(config.scrolledDistanceClass);
				} else if (diff < 0 && 0 - diff >= config.scrollDistanceUp) {
					// Scroll up
					triggerPoint = window.pageYOffset;
					document.body.classList.remove(config.scrolledDistanceClass);
				}
			}
		});
		window.addEventListener('scroll', scrollDebouncer.run);
		scrollDebouncer.runNow();
	}
}